import { UseQueryResult } from '@tanstack/react-query';

export type OSType = 'win' | 'mac';
export type ObjectValues<T> = T[keyof T];

export type DeepNullable<T> = {
  [K in keyof T]: DeepNullable<T[K]> | null;
};

export enum MessageType {
  Info,
  Warning,
  Success,
  NotDefined,
}

export type ServerResponse<T> = {
  errorMessage: string;
  result: T;
  messageType: MessageType;
  timeGenerated: string;
};

export type QueryResults<T extends readonly unknown[]> = {
  [K in keyof T]: UseQueryResult<T[K]>;
};

export enum VintageYearEnum {
  old = '0',
  new = '1',
}

export enum FiscalYearRangeEnum {
  CurrentYear = 0,
  MostRecentCompleteFiscalYear = 1,
  TwoCompleteFiscalYears = 2,
  ThreeCompleteFiscalYears = 3,
}

export enum ProcessingStatusEnum {
  Pending = 0,
  Started = 1,
  Failed = 2,
  Completed = 3,
  Deleting = 4,
}

export enum CdfiStatsNameEnum {
  LOAN = 'loan',
  DOLLAR = 'dollar',
  ACCOUNT_HOLDERS = 'accountHolders',
}
